<template>
    <div v-for="(group, groupIndex) in paginatedGroups" :key="groupIndex" class="sub-news-wrapper fontColor2">
        <templaate v-if="group.image">
            <img :src="group.image" :alt="group.alt || 'News image'" class="group-image" />
        </templaate>
        <div v-for="(item, itemIndex) in group.items" :key="itemIndex" class="item-box montserrat-500">
            <p :class="(groupIndex + itemIndex) % 2 === 0 ? 'featured-red' : 'featured-orange'">Featured</p>
            <br/>
            <p class="poppins-semi heading-title">{{ item.a }}</p>
            <br/>
            <p style="color: #666666;">{{ item.b }}</p>
            <br/>
            <p @click="openModal(item)" class="btn-readmore" :class="(groupIndex + itemIndex) % 2 === 0 ? 'featured-red' : 'featured-orange'">
                <span style="cursor: pointer;">Read More</span>
            </p>
            <br/>
            <p>By <span class="montserrat-600">Editor MMCOA</span>, {{ item.d }}</p>
        </div>
    </div>

     <!-- Pagination :show-total="(total) => `Total ${total} items`"-->
     <a-pagination
      v-model:current="currentPage"
      :total="groups.length"
      :page-size="pageSize"
      :show-size-changer="false"
      style="text-align: center"
    />

    <ShareModal v-model:visible="showModal" @ok="handleOk">
        <!-- Custom layout based on item -->
        <div v-if="activeItem === '2025-Content-6'" class="montserrat-500">
            <h3>09.07.2025 (星期三Wednesday)</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 9/7/2025</p>
            <br/>
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid087eVAFAyUGsaKBWWR2PALpymKDFVUHoq1e69XvnN7rp8E6Np6THYv1x9znkS7qbkl%26id%3D100057645450325&show_text=true&width=500"
                height="735" 
                style="border:none;overflow:hidden; width: 100%;" scrolling="no" frameborder="0" allowfullscreen="true" 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
        </div>
        <div v-if="activeItem === '2025-Content-5'" class="montserrat-500">
            <h3>29.06.2025 (星期天Sunday)</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 29/6/2025</p>
            <br/>
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0VtBRJg31ydamVF83baqSaH5aFCsRg7zH6hfvRYw4K9W3cMJV5X2brFLkRn5TFLNl%26id%3D100057645450325&show_text=true&width=500" 
                height="773" 
                style="border:none;overflow:hidden; width: 100%;" scrolling="no" frameborder="0" allowfullscreen="true" 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
        </div>
        <div v-if="activeItem === '2025-Content-4'" class="montserrat-500">
            <h3>25/06/2025 (星期三 Wednesday)</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 25/6/2025</p>
            <br/>
            <p>秘书长吴年靖代表MMCOA (1987) 马来西亚建筑商总会（MBAM） 焦点小组对话会。Secretary General Goh Lian Chin representing MMCOA (1987) attending MBAM Focus Group Dialogue.</p>
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0aBDxZNTb2rLsFF49EWS7ofk7dAUUo42eoSyMLvqzSUrmmiaGw8XGhGRQLc7YcVS4l%26id%3D100057645450325&show_text=true&width=500" 
                height="812" 
                style="border:none;overflow:hidden; width: 100%;" scrolling="no" frameborder="0" allowfullscreen="true" 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
        </div>
        <div v-if="activeItem === '2025-Content-3'" class="montserrat-500">
            <h3>MMCOA (1987) participated in the seminar organized by the Road Transport Department (JPJ).</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 24/6/2025</p>
            <br/>
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0iNqLfzL65itqZTeqEkmeor1AP5vDjERPpzZQG3qmhyeYkgbN5iV8ZEztKzzxqN1Rl%26id%3D100057645450325&show_text=true&width=500" 
                height="735" 
                style="border:none;overflow:hidden; width: 100%;" scrolling="no" frameborder="0" allowfullscreen="true" 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
        </div>
        <div v-if="activeItem === '2025-Content-2'" class="montserrat-500">
            <h3>24.06.2025</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 24/6/2025</p>
            <br/>
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02tgRyLzynXdqwwFcH5KJKQPKUVfbZM3TS5V8isV76QLem3UPX4sezA37ADnyuyJLjl%26id%3D100057645450325&show_text=true&width=500" 
                height="481" 
                style="border:none;overflow:hidden; width: 100%;" scrolling="no" frameborder="0" allowfullscreen="true" 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
        </div>
        <div v-if="activeItem === '2025-Content-1'" class="montserrat-500">
            <h3>22.06.2025 (星期日Sunday)</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 23/6/2025</p>
            <br/>
            <p>
                马来西亚吊秤车同业公会（1987）于沙登喜来登酒家圆满举办38周年庆慰劳宴暨第19届理事会就职典礼。
                <br/>
                由主席雷志方带领新任理事进行宣誓仪式，正式展开新一届理事会的任期。雷主席在致词中感谢会员的信任，
                并特别感谢38周年会庆晚宴筹委会及全体理事在过去几个月的努力，让刚举办的晚宴得以圆满成功，各项安排也井然有序。
                他表示，新届理事会将继续团结一致，积极推动会务发展，维护会员权益，稳步应对行业面对的政策与市场变化。
                <br/>
                活动贵宾YB杨美盈女士，蒲种区国会议员，也应邀出席并致词。她肯定公会多年来在提升行业安全标准及促进同业团结方面的贡献，
                并表示，若公会在电子发票或SST征收范围调整等政策改革中遇到任何实际困难或有良好建议，欢迎随时联系她，她将尽力提供协助，
                并把意见反映给有关单位。
                <br/>
                现场也举行了顾问委任状颁发仪式，由主席雷志方亲自颁发予甯奇炜及郑桂发，以表彰他们对公会的持续支持与宝贵贡献。
                <br/>
                活动最后进行大合照，嘉宾、理事与会员一同合影留念，为当天画下圆满句点，也为公会迈入新阶段立下良好开端。
                <br/>
                <br/>
                MMCOA (1987) successfully held its 38th Anniversary Appreciation Banquet and Swearing-In Ceremony of the 19th Management Committee.
                <br/>
                The event began with the official swearing-in ceremony of the newly elected committee, led by President Mr. Luei 
                Chee Fong. In his speech, Mr. Luei expressed sincere gratitude to all members for their continued trust and support. 
                He also extended special thanks to the 38th Anniversary Dinner Organising Committee and all committee members for their 
                months of preparation and coordination, which contributed to the smooth and successful dinner. He added that the new 
                term will focus on strengthening collaboration, safeguarding industry interests, and helping members adapt to current 
                regulatory and market changes.
                <br/>
                Guest of Honour YB Puan Yeo Bee Yin, MP for Puchong, was also present and delivered a speech. She recognised the Association’s 
                consistent efforts in improving safety standards and unity among industry players. She expressed her readiness to assist the 
                Association should there be any challenges or suggestions related to e-invoicing or SST expansion, and will help convey their 
                concerns to the relevant authorities.
                <br/>
                The event continued with the presentation of advisor appointment certificates to Mr. Liam Kei Wai and Mr. Chung Kwai Fatt, 
                personally handed over by the President in recognition of their long-standing support and contribution to the Association.
                <br/>
                The day concluded with a group photo session, capturing the presence of guests, committee members, and Association members. 
                It marked a meaningful and encouraging start to the new term, reflecting the Association’s unity and commitment toward 
                continued progress.
            </p>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news2025June23Images"
                    :key="index"
                    :width="200"
                    :src="require(`@/assets/images/news/news-2025/16-june/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>


        <div v-if="activeItem === 'Content-1'" class="montserrat-500">
            <h3>Crawler Crane Inspection</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 19/12/2019</p>
            <br/>
            <p>Update on progress of Crawler Crane Inspection</p>
            <p>
                JKKP had appointed a person-in-charge to focus on crawler crane inspection and requested proposal to be sent for 
                their viewing with the aim to shorten the process of decision. The meeting had been rescheduled to 30th December.
            </p>
            <br/>
            <p>
                复带式吊车检验的最新讯息
            </p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/ccl-001.jpg')" />
            </a-image-preview-group>
            <br/>
            <br/>
            <p>
                JKKP指派了特定的负责人，并要求公会先把检验方式的草稿提呈上去，让他们过目及讨论，希望能够加快决定的过程，因此原定的会议已经被展延到12月30日。
            </p>
        </div>
        <div v-else-if="activeItem === 'Content-2'" class="montserrat-500">
            <h3>Discussion with JKKP Putrajaya on Crawler Inspection / 与 JKKP 讨论检验复带式起重机事宜</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 15/11/2019</p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/news-2/news-2-2.jpg')"/>
                <a-image :width="200" :src="require('@/assets/images/news/news-2/news-2-1.jpg')" />
            </a-image-preview-group>
            <br/>
            <br/>
            <p>
                讨论过程顺畅，双方达到了一定的共识，已定了下次讨论会议的日期。将会在下星期回到公会讨论及重新整理资料，为下一回的讨论会议作准备。
            </p>
            <p>
                Discussion with JKKP this morning was smooth, mutual understanding had been reached and a date for the next discussion had been fixed. Will meet next at MMCOA to have more details in preparation for the next meeting.
            </p>
        </div>
        <div v-else-if="activeItem === 'Content-2-1'" class="montserrat-500">
            <h3>Crawler Crane Inspection / 复带式起重机</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 14/11/2019</p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/ccl-002.jpg')" />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-2-2'" class="montserrat-500">
            <h3>New Administrator / 新管理员</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 11/11/2019</p>
            <br/>
            <p>Kindly take note that Eddie has quit. I am the Exec Sec, TS Lee. I am learning to  manage this website. Please suggest and advise to make the web page better. Thank you</p>
            <p>文勇已经辞职。我是执行秘书，李德信。我正学习如何管理这个网站。请给予意见及指点如何把这个网页做的更好。谢谢</p>
        </div>
        <div v-else-if="activeItem === 'Content-2-3'" class="montserrat-500">
            <h3>Press Conference on 20 Oct 2019</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 24/10/2019</p>
            <br/>
            <p>Press Conference 记者招待会</p>
            <p>Date: 20 Oct 2019</p>
            <p>Time: 12pm</p>
            <p>Venue: Hotel Neo+, Penang</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news3Images"
                    :key="index"
                    :width="200"
                    :src="require(`@/assets/images/news/news-3/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-2-4'" class="montserrat-500">
            <h3>7th National Mobile Crane Industry Fellowship – 20Oct2019</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 24/10/2019</p>
            <br/>
            <p>Organized by : 北马吊车同业公会 Mobile Crane Association North Malaysia</p>
            <p>Date: 20 Oct 2019</p>
            <p>Time: 8.30am ~ 12pm</p>
            <p>Venue: Hotel Neo+, Penang</p>
            <p>
                Attendees出席者：
                <br/>
                北马吊车同业公会 Mobile Crane Association North Malaysia
                <br/>
                马来西亚吊秤车同业公会(1987) Malaysia Mobile Crane Owners Association (1987)
                <br/>
                柔佛州吊秤车同业公会 Johor Mobile Crane Owners’ Association
                <br/>
                东马吊秤车同业代表 Representative from Mobile Crane Owners East Malaysia
                <br/>
                台湾高雄市起重机具协会Kaohsiung Crane Association,Taiwan
            </p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news4Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-4/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-3'" class="montserrat-500">
            <h3>Seminar: Best Practice to Improve Machine and Equipment Productivity</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 24/10/2019</p>
            <br/>
            <p>Best Practice to Improve Machine and Equipment Productivity</p>
            <p>提高机器和设备生产率的最佳实践</p>
            <p>Date: 17 October 2019</p>
            <p>Time: 8am-4.45pm</p>
            <p>Venue: Sime Darby Industrial Sdn Bhd</p>
            <p>Speaker:Felice Stocco (Senior Industry Specialist Global Constuction & Infrastructure)</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news5Images"
                    :key="index"
                    :width="200"
                    :src="require(`@/assets/images/news/news-5/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-4'" class="montserrat-500">
            <h3>**IMPORTANT NOTICE / 重要通告**</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 11/10/2019</p>
            <br/>
            <p class="montserrat-600">Objective / 目的</p>
            <p>
                Association received from members saying that many of the mobile crane operators failed their JKKP competency 
                test because they are not good in Bahasa Malaysia (language barrier). In a meeting, JKKP agreed to conduct special 
                competency test for these operators. Kindly fill up the survey form so that we can submit the information to JKKP.
            </p>
            <p>
                公会收到会员的反映说他们有很多的吊秤车操作员由于不熟悉马来文，导致多次无法通过JKKP执照考试。在
                会议里，JKKP同意会举办个别的考试于这些操作员。如果你有面对这方面的问题，请协助填写以下表格。谢谢。
            </p>
            <p>
                *Please email us this form before 31/10/2019:   survey.mmcoa@gmail.com
                请在10月31日前回覆至： survey.mmcoa@gmail.com
            </p>
            <p>Venue: Sime Darby Industrial Sdn Bhd</p>
            <p>Speaker:Felice Stocco (Senior Industry Specialist Global Constuction & Infrastructure)</p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/form-001.jpg')" />
                <a-image :width="200" :src="require('@/assets/images/news/form-002.jpg')" />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-5'" class="montserrat-500">
            <h3>Coming Event: 7th National Mobile Crane Industry Fellowship 第七届全国吊秤车同业交流会</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 25/09/2019</p>
            <br/>
            <p>Coming Event: 7th National Mobile Crane Industry Fellowship</p>
            <p>活动预告：第七届全国吊秤车同业交流会</p>
            <p>Date: 20-10-2019 (Sunday)</p>
            <p>Venue: Penang</p>
        </div>
        <div v-else-if="activeItem === 'Content-6'" class="montserrat-500">
            <h3>Visiting Kaohsiung Crane Association,Taiwan 拜访台湾高雄市起重机具协会 22 Sept 2019</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 25/09/2019</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news6Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-6/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-7'" class="montserrat-500">
            <h3>Seminar: Enhance Safety Awareness Of Crane Operation 24 August 2019</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 25/09/2019</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news7Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-7/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-8'" class="montserrat-500">
            <h3>MBAM OneBuild Construction Industry Exhibition & Conference ~ 13-15 Nov 2018</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 28/11/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news8Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-8/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-9'" class="montserrat-500">
            <h3>M&E Productivity Nexus Governing Committee Meeting 2/2018 ～ 08 Nov2018</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 28/11/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news9Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-9/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-10'" class="montserrat-500">
            <h3>ICW &Asean Super 8 Official Launch & Press Conference ~ 25 Oct 2018</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 28/11/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/news-10/news-10-1.jpg')" />
                <a-image :width="200" :src="require('@/assets/images/news/news-10/news-10-2.jpg')" />
                <a-image :width="200" :src="require('@/assets/images/news/news-10/news-10-3.jpg')" />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-11'" class="montserrat-500">
            <h3>中秋晚会暨2017年度会员子女教育奖励金颁发典礼- 13 Oct 2018</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 28/11/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news11Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-11/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-12'" class="montserrat-500">
            <h3>Meeting with MBAM</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 12/10/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news12Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-12/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
        </div>
        <div v-else-if="activeItem === 'Content-13'" class="montserrat-500">
            <h3>Meeting with CIDB</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 11/10/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image :width="200" :src="require('@/assets/images/news/news-13.jpg')" />
            </a-image-preview-group>
            <p class="montserrat-600">Meeting with CIDB</p>
            <p>
                Date: 10/10/2018 (Wednesday)<br/>
                Time: 10.30am – 12.30pm<br/>
                Venue: CIDB Office, PWTC
            </p>
            <p>Topic discussion on mobile crane operation skill competition.</p>
            <p>在CIDB 开会，讨论吊秤车操作技术比赛事宜。</p>
        </div>
        <div v-else-if="activeItem === 'Content-14'" class="montserrat-500">
            <h3>中秋晚会暨2017年度会员子女教育奖励金颁发典礼- 13 Oct 2018</h3>
            <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 28/11/2018</p>
            <br/>
            <a-image-preview-group>
                <a-image
                    v-for="(img, index) in news14Images"
                    :key="index"
                    :width="100"
                    :src="require(`@/assets/images/news/news-14/${img}`)"
                    :alt="`Press Conference Image ${index + 1}`"
                />
            </a-image-preview-group>
            <p class="montserrat-600">MPC Teh Tarik session on Productivity Improvement Programme Through ezBusiness Excellence</p>
            <p>
                Date: 09/10/2018 (Tuesday)<br/>
                Time: 8.30am – 1.00pm<br/>
                Venue: Malaysia International Trade And Exhibition Center (MITEC),Kuala Lumpur
            </p>
            <br/>
            <p class="montserrat-600">Topic of diccussion:</p>
            <p>
                * Started with an introduction of the function and role of MPC
                <br/>
                * Sharing of strategic management by Exis Tech. Full elaboration by its Director on core values of the company, implementation of management science, etc
                <br/>
                * Cooperation and commercialization of inventions and innovation with various institutions.
                <br/>
                * Hands on session using the ezBE apps for evaluating company performance.
                Info just received from MPC
            </p>
        </div>
        <!-- <div v-else>
            <h4>Generic Layout</h4>
            <p>You clicked on: <strong>{{ activeItem }}</strong></p>
            <p>From group: <strong>{{ activeImage }}</strong></p>
        </div> -->
    </ShareModal>

</template>

<script>
import ShareModal from '@/components/ShareModal.vue'
import { Pagination } from 'ant-design-vue';

export default {
  name: 'News & Event component',
  components: {
    ShareModal,
    Pagination
  },
    data() {
        return {
            news2025June23Images: Array.from({ length: 9 }, (_, i) => `news-2025-${i + 1}.jpg`),
            news3Images: Array.from({ length: 7 }, (_, i) => `news-3-${i + 1}.jpg`),
            news4Images: Array.from({ length: 39 }, (_, i) => `news-4-${i + 1}.jpg`),
            news5Images: Array.from({ length: 5 }, (_, i) => `news-5-${i + 1}.jpg`),
            news6Images: Array.from({ length: 10 }, (_, i) => `news-6-${i + 1}.jpg`),
            news7Images: Array.from({ length: 25 }, (_, i) => `news-7-${i + 1}.jpg`),
            news8Images: Array.from({ length: 7 }, (_, i) => `news-8-${i + 1}.jpg`),
            news9Images: Array.from({ length: 6 }, (_, i) => `news-9-${i + 1}.jpg`),
            news11Images: Array.from({ length: 14 }, (_, i) => `news-11-${i + 1}.jpg`),
            news12Images: Array.from({ length: 15 }, (_, i) => `news-12-${i + 1}.jpg`),
            news14Images: Array.from({ length: 4 }, (_, i) => `news-14-${i + 1}.jpg`),
            groups: [
                { 
                    image: require('@/assets/images/news/news-2025/9-july/news-2025-1.jpg'),
                    items: [
                        { 
                            a: 'MMCOA (1987) Deputy President and Committee Member', 
                            b: 'attended a closed-door engagement session with the Ministry of Finance and the Royal...', 
                            c: '2025-Content-6',
                            d: '09 July 2025' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-2025/29-june/news-2025-1.jpg'),
                    items: [
                        { 
                            a: 'Malaysia Heavy Construction Equipment Owners Association (MHCEOA)', 
                            b: 'held in conjunction with the 2025 Heavy Machinery Exhibition at Ideal...', 
                            c: '2025-Content-5',
                            d: '29 June 2025' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-2025/25-june/news-2025-1.jpg'),
                    items: [
                        { 
                            a: 'Secretary General Goh Lian Chin representing MMCOA', 
                            b: 'attending MBAM Focus Group Dialogue...', 
                            c: '2025-Content-4',
                            d: '25 June 2025' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-2025/24-june/news-2025-1.jpg'),
                    items: [
                        { 
                            a: 'Road Transport Department (JPJ)', 
                            b: 'MMCOA (1987) participated in the seminar organized by the Road Transport Department (JPJ)...', 
                            c: '2025-Content-3',
                            d: '24 June 2025' 
                        },
                    ]
                },
                { 
                    image: '', 
                    items: [
                        { 
                            a: 'Malaysia Sin Chew Daily ', 
                            b: '感谢 马来西亚星洲日报 Malaysia Sin Chew Daily  的报导。', 
                            c: '2025-Content-2',
                            d: '24 June 2025' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-2025/16-june/news-2025-9.jpg'), 
                    items: [
                        { 
                            a: '38th Anniversary Appreciation Banquet', 
                            b: 'MMCOA (1987) successfully held its 38th Anniversary Appreciation Banquet and Swearing-In Ceremony of...', 
                            c: '2025-Content-1',
                            d: '23 June 2025' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/ccl-001.jpg'), 
                    items: [
                        { 
                            a: 'Crawler Crane Inspection', 
                            b: 'Update on progress of Crawler Crane Inspection JKKP had appointed a person-in-charge to focus on crawler crane inspection and...', 
                            c: 'Content-1',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-2.jpg'), 
                    items: [
                        { 
                            a: 'Discussion with JKKP Putrajaya on Crawler Inspection / 与 JKKP 讨论检验复带式起重机事宜', 
                            b: '讨论过程顺畅，双方达到了一定的共识，已定了下次讨论会议的日期。将会在下星期回到公会讨论及重新整理资料，为下一回的讨论会议作准备。 Discussion...', 
                            c: 'Content-2',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/ccl-001.jpg'), 
                    items: [
                        { 
                            a: 'Crawler Crane Inspection / 复带式起重机', 
                            b: '', 
                            c: 'Content-2-1',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: '', 
                    alt: 'New Administrator',
                    items: [
                        { 
                            a: 'New Administrator / 新管理员', 
                            b: 'Kindly take note that Eddie has quit. I am the Exec Sec, TS Lee. I am learning to  manage this website...', 
                            c: 'Content-2-2',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-3/news-3-3.jpg'), 
                    items: [
                        { 
                            a: 'Press Conference on 20 Oct 2019', 
                            b: 'Press Conference 记者招待会 Date: 20 Oct 2019 Time: 12pm Venue: Hotel Neo+, Penang', 
                            c: 'Content-2-3',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-4/news-4-31.jpg'), 
                    items: [
                        { 
                            a: '7th National Mobile Crane Industry Fellowship – 20Oct2019', 
                            b: '7th National Mobile Crane Industry Fellowship 第七届全国吊秤车同业交流会 Organized by : 北马吊车同业公会...', 
                            c: 'Content-2-4',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-5/news-5-2.jpg'), 
                    items: [
                        { 
                            a: 'Seminar: Best Practice to Improve Machine and Equipment Productivity', 
                            b: 'Best Practice to Improve Machine and Equipment Productivity 提高机器和设备生产率的最佳实践 Date: 17 October 2019...', 
                            c: 'Content-3',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: '', 
                    items: [
                        { 
                            a: '**IMPORTANT NOTICE / 重要通告**', 
                            b: 'Survey Form / 调查问卷 Objective / 目的 Association received from members saying that many of the mobile crane...', 
                            c: 'Content-4',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: '', 
                    items: [
                        { 
                            a: 'Coming Event: 7th National Mobile Crane Industry Fellowship 第七届全国吊秤车同业交流会', 
                            b: 'Coming Event: 7th National Mobile Crane Industry Fellowship 活动预告：第七届全国吊秤车同业交流会...', 
                            c: 'Content-5',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-6/news-6-6.jpg'), 
                    items: [
                        { 
                            a: 'Visiting Kaohsiung Crane Association,Taiwan 拜访台湾高雄市起重机具协会 22 Sept 2019', 
                            b: '', 
                            c: 'Content-6',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-7/news-7-15.jpg'), 
                    items: [
                        { 
                            a: 'Seminar: Enhance Safety Awareness Of Crane Operation 24 August 2019', 
                            b: '', 
                            c: 'Content-7',
                            d: '6 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-8/news-8-7.jpg'), 
                    items: [
                        { 
                            a: 'MBAM OneBuild Construction Industry Exhibition & Conference ~ 13-15 Nov 2018', 
                            b: '', 
                            c: 'Content-8',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-9/news-9-6.jpg'), 
                    items: [
                        { 
                            a: 'M&E Productivity Nexus Governing Committee Meeting 2/2018 ～ 08 Nov2018', 
                            b: '', 
                            c: 'Content-9',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-10/news-10-3.jpg'), 
                    items: [
                        { 
                            a: 'ICW &Asean Super 8 Official Launch & Press Conference ~ 25 Oct 2018', 
                            b: '', 
                            c: 'Content-10',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-11/news-11-13.jpg'), 
                    items: [
                        { 
                            a: '中秋晚会暨2017年度会员子女教育奖励金颁发典礼- 13 Oct 2018', 
                            b: '', 
                            c: 'Content-11',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-12/news-12-9.jpg'), 
                    items: [
                        { 
                            a: 'Meeting with MBAM', 
                            b: 'Date: 12 Oct 2018 Venue: MBAM Office, KL Attending dialogue meeting held...', 
                            c: 'Content-12',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-13.jpg'), 
                    items: [
                        { 
                            a: 'Meeting with CIDB', 
                            b: 'Meeting with CIDB Date: 10/10/2018 (Wednesday) Time: 10.30am – 12.30pm Venue: CIDB Office, PWTC Topic discussion...', 
                            c: 'Content-13',
                            d: '7 years ago' 
                        },
                    ]
                },
                { 
                    image: require('@/assets/images/news/news-14/news-14-3.jpg'), 
                    items: [
                        { 
                            a: 'MPC Teh Tarik session on Productivity Improvement Programme Through ezBusiness Excellence', 
                            b: 'MPC Teh Tarik session on Productivity Improvement Programme Through ezBusiness Excellence Date: 09/10/2018 (Tuesday)...', 
                            c: 'Content-14',
                            d: '7 years ago' 
                        },
                    ]
                },
            ],
            showModal: false,
            activeItem: '',
            activeImage: '',
            currentPage: 1,
            pageSize: 4, // number of groups per page
        }
    },
    methods: {
        openModal(item) {
            this.activeItem = item.c
            this.showModal = true
        },
        handleOk() {
            console.log('OK clicked on:', this.activeItem)
            this.showModal = false
        }
    },
    computed: {
        paginatedGroups() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.groups.slice(start, start + this.pageSize);
        },
    },
}

</script>

<style scoped>
p {margin: 0;}
.sub-news-wrapper {
    width: 80%;
    margin: 1% auto 5% auto;
    font-size: 11px;
    text-align: center;
}
.sub-news-wrapper img {
    width: 80%;
}
.item-box {
    padding-top: 1%;
    line-height: 1;
}
.heading-title {
    font-size: 15px;
}
.btn-readmore {
    text-decoration: underline;
    font-style: italic;
}
.btn-readmore:hover {
    color: #666666;
    transition: color 0.3s ease;
}

:deep(.ant-image ) {
    margin-right: 10px;
    margin-bottom: 10px;
}

@media screen and (min-width: 640px) {
    .sub-news-wrapper {
        display: flex;
        gap: 20px;
        font-size: 12px;
        text-align: left;
    }
    .sub-news-wrapper img {
        width: 300px;
    }
}

</style>